/*
 * @Author: tony.zhu
 * @Date: 2023-12-01 11:00:44
 * @LastEditTime: 2025-08-19 11:17:31
 * @LastEditors: tony.zhu
 * @Description: 
 */


// 默认是-1  1 =>有数据 2=> 无数据
const CONTENT_MENU = {
    NO_DATA: 2,
    HAVE_DATA: 1,
    DEFAULT: -1
}

const ANSWER_CONTENT_TYPE_ENUM = {
    'TEXT': {
        code: 'message',
        id: 1,
        label: '文本',
    },
    'IMAGE': {
        code: 'image',
        id: 2,
        label: '图片'
    },
    'VIDEO': {
        code: 'video',
        id: 3,
        label: '视频'
    },
    'CHART': {
        code: 'chart',
        id: 4,
        label: '图表'
    }
}

export {
    CONTENT_MENU,
    ANSWER_CONTENT_TYPE_ENUM
}